import { dateConverter } from "../../helpers/functions";

const generatePrintContent = (data) => {
  const logoUrl = `${window.location.origin}/logo.png`;
  return `
  <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; max-width: 100%; color: #333; line-height: 1.5; padding: 10px;">
    
    <!-- Brand Header -->
    <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #1e3d59; padding-bottom: 15px; margin-bottom: 20px;">
      <div style="display: flex; align-items: center; gap: 15px;">
        <img src="${logoUrl}" alt="Sea Tech Marine Logo" style="height: 65px; width: auto; object-fit: contain;" />
        <div>
          <h1 style="font-size: 24px; font-weight: 700; color: #1e3d59; margin: 0; letter-spacing: 0.5px;">Sea Tech Marine</h1>
          <span style="font-size: 11px; color: #7f8c8d; font-weight: 600; letter-spacing: 1px;">Service Management</span>
        </div>
      </div>
      <div style="text-align: right;">
        <h2 style="font-size: 18px; font-weight: 700; color: #1e3d59; margin: 0; letter-spacing: 0.5px;">Customer Profile</h2>
        <p style="font-size: 12px; color: #7f8c8d; margin: 5px 0 0 0; font-weight: 500;">
          Customer Summary Details
        </p>
      </div>
    </div>

    <!-- Info Cards Grid -->
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
      <tr>
        <td style="width: 50%; padding-right: 10px; vertical-align: top;">
          <div style="background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 6px; padding: 15px; min-height: 100px;">
            <h3 style="font-size: 12px; color: #1e3d59; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-top: 0; margin-bottom: 10px; font-weight: 700; letter-spacing: 0.5px;">Contact Information</h3>
            <table style="width: 100%; font-size: 13px; border-collapse: collapse;">
              <tr>
                <td style="padding: 3px 0; color: #6c757d; width: 70px; font-weight: 500;">Name:</td>
                <td style="padding: 3px 0; color: #212529; font-weight: 600;">${data.name || "-"}</td>
              </tr>
              <tr>
                <td style="padding: 3px 0; color: #6c757d; font-weight: 500;">Mobile:</td>
                <td style="padding: 3px 0; color: #212529; font-weight: 600;">${data.mobile || "-"}</td>
              </tr>
            </table>
          </div>
        </td>
        <td style="width: 50%; padding-left: 10px; vertical-align: top;">
          <div style="background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 6px; padding: 15px; min-height: 100px;">
            <h3 style="font-size: 12px; color: #1e3d59; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-top: 0; margin-bottom: 10px; font-weight: 700; letter-spacing: 0.5px;">Account Balance</h3>
            <table style="width: 100%; font-size: 13px; border-collapse: collapse;">
              <tr>
                <td style="padding: 3px 0; color: #6c757d; width: 120px; font-weight: 500;">Total Due Balance:</td>
                <td style="padding: 3px 0; color: ${Number(data.dueAmount || 0) > 0 ? '#dc3545' : '#198754'}; font-weight: 700;">${Number(data.dueAmount || 0).toFixed(2)}</td>
              </tr>
              <tr>
                <td style="padding: 3px 0; color: #6c757d; font-weight: 500;">Status:</td>
                <td style="padding: 3px 0;">
                  <span style="display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: 700; ${Number(data.dueAmount || 0) <= 0 ? 'background-color: #d1fae5; color: #065f46;' : 'background-color: #fee2e2; color: #991b1b;'}">
                    ${Number(data.dueAmount || 0) <= 0 ? 'No Balance' : 'Payment Due'}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </table>

    <!-- Payments List Table -->
    ${
      data.payments?.length
        ? `
      <div style="margin-bottom: 25px;">
        <h3 style="font-size: 13px; color: #1e3d59; margin-bottom: 10px; font-weight: 700; letter-spacing: 0.5px;">Job / Payment Records</h3>
        <div style="border: 1px solid #dee2e6; border-radius: 6px; overflow: hidden;">
          <table style="width: 100%; border-collapse: collapse; font-size: 13px; text-align: left;">
            <thead>
              <tr style="background-color: #1e3d59; color: white;">
                <th style="padding: 10px 15px; font-weight: 600; width: 8%; text-align: center; border: none;">#</th>
                <th style="padding: 10px 15px; font-weight: 600; width: 22%; text-align: center; border: none;">Date</th>
                <th style="padding: 10px 15px; font-weight: 600; width: 45%; border: none;">Boat Name</th>
                <th style="padding: 10px 15px; font-weight: 600; width: 25%; text-align: right; border: none;">Due Amount</th>
              </tr>
            </thead>
            <tbody>
              ${data.payments
                .map(
                  (item, index) => `
                <tr style="border-bottom: 1px solid #dee2e6; background-color: ${index % 2 === 0 ? '#ffffff' : '#f8f9fa'};">
                  <td style="padding: 10px 15px; color: #6c757d; text-align: center;">${index + 1}</td>
                  <td style="padding: 10px 15px; text-align: center; color: #212529;">${dateConverter(item.date)}</td>
                  <td style="padding: 10px 15px; color: #212529; font-weight: 500;">${item.boat || "-"}</td>
                  <td style="padding: 10px 15px; text-align: right; color: ${Number(item.dueAmount || 0) > 0 ? '#dc3545' : '#198754'}; font-weight: 600;">
                    ${Number(item.dueAmount || 0).toFixed(2)}
                  </td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
        </div>
      </div>
    `
        : ""
    }

    <!-- Footer -->
    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #dee2e6; padding-top: 20px;">
      <p style="font-size: 11px; color: #7f8c8d; margin: 0;">Sea Tech Marine - Service Management & Solutions</p>
    </div>

  </div>
  `;
};

const shareWithAlternativeMethod = async (htmlContent, data) => {
  const { default: html2canvas } = await import("html2canvas");
  const { PDFDocument } = await import("pdf-lib");

  const tempDiv = document.createElement("div");
  tempDiv.style.position = "fixed";
  tempDiv.style.left = "0";
  tempDiv.style.top = "0";
  tempDiv.style.width = "210mm";
  tempDiv.style.padding = "20px";
  tempDiv.style.background = "white";
  tempDiv.style.zIndex = "-1";
  tempDiv.innerHTML = htmlContent;
  document.body.appendChild(tempDiv);

  try {
    const canvas = await html2canvas(tempDiv, {
      scale: 3,
      logging: false,
      useCORS: true,
      allowTaint: true,
      windowWidth: tempDiv.scrollWidth,
      windowHeight: tempDiv.scrollHeight,
    });

    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595.28, 841.89]);

    const pngImage = await pdfDoc.embedPng(canvas.toDataURL("image/png", 1.0));
    const scale = Math.min(page.getWidth() / canvas.width, page.getHeight() / canvas.height);

    page.drawImage(pngImage, {
      x: 0,
      y: page.getHeight() - canvas.height * scale,
      width: canvas.width * scale,
      height: canvas.height * scale,
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const fileName = `customer_${data.name || "Statement"}.pdf`;

    if (navigator.share && navigator.canShare({ files: [new File([blob], fileName)] })) {
      await navigator.share({
        title: "Customer Details",
        files: [new File([blob], fileName, { type: "application/pdf" })],
      });
    } else {
      const pdfUrl = URL.createObjectURL(blob);
      const newWindow = window.open(pdfUrl, "_blank");

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
        if (newWindow && !newWindow.closed) {
          newWindow.focus();
        }
      }, 3000);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  } finally {
    document.body.removeChild(tempDiv);
  }
};

export const handlePrint = async (data) => {
  try {
    window.dispatchEvent(new CustomEvent("show-print-loader", { detail: true }));
    
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "1px";
    iframe.style.height = "1px";
    iframe.style.left = "-9999px";
    iframe.style.top = "-9999px";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const printContent = `
      <html lang="en">
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Customer Details - ${data.boat || data.name || ""}</title>
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
      }
      
      body {
        padding: 20px;
        color: #333;
        background: white;
      }

      @media print {
        @page {
          margin: 10mm;
          size: A4;
        }
        
        body {
          padding: 0;
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
          background: white !important;
        }
        
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    </style>
  </head>
  <body>
        ${generatePrintContent(data)} 
      </body>
      </html>
    `;
    await shareWithAlternativeMethod(printContent, data);
  } catch (error) {
    console.error("Error in handlePrint:", error);
  } finally {
    window.dispatchEvent(new CustomEvent("show-print-loader", { detail: false }));
  }
};
